import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  toggle(event) {
    const button = event.currentTarget;
    const targetSelector = button.getAttribute("data-accordion-target");
    const target = document.querySelector(targetSelector);

    document.querySelectorAll(".accordion-content").forEach(content => {
      if (content !== target) {
        content.classList.add("hidden");
        const siblingButton = content.closest(".accordion-item").querySelector(".accordion-header");
        siblingButton.setAttribute("aria-expanded", "false");
        siblingButton.querySelector(".accordion-icon span")?.classList.remove("rotate-180");
      }
    });

    const isHidden = target.classList.contains("hidden");
    target.classList.toggle("hidden", !isHidden);
    button.setAttribute("aria-expanded", String(isHidden));
    button.querySelector(".accordion-icon span")?.classList.toggle("rotate-180", isHidden);
  }
}
